{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              98.57430848533579,
              9.91087601931362
            ],
            [
              98.02022701199644,
              9.28150888792662
            ],
            [
              97.98559276672313,
              7.64179623841251
            ],
            [
              99.8843854760321,
              6.1207382815304925
            ],
            [
              101.10510980079073,
              6.213605894366793
            ],
            [
              101.84053465116568,
              5.709572981950146
            ],
            [
              102.50861483351889,
              6.207233652743028
            ],
            [
              102.90206127265412,
              11.766422466794879
            ],
            [
              102.35014240570888,
              13.66240399214486
            ],
            [
              103.66573060557397,
              14.484299648951762
            ],
            [
              105.45628926310752,
              14.474428820099305
            ],
            [
              104.74478532712567,
              17.4764643587705
            ],
            [
              103.43991911786327,
              18.49160442240428
            ],
            [
              101.02770268218751,
              17.579444501917237
            ],
            [
              100.08308895956691,
              20.533009409505496
            ],
            [
              97.94574320536532,
              19.80646985375627
            ],
            [
              97.34485179994584,
              18.561856163866253
            ],
            [
              98.87013220957601,
              16.37382593913243
            ],
            [
              98.56093951674904,
              15.318682855450973
            ],
            [
              98.23367284432885,
              14.95917292987508
            ],
            [
              99.12107052761064,
              13.806454077560858
            ],
            [
              99.13658136622666,
              12.81330157243083
            ],
            [
              99.66898094632887,
              11.810761279986764
            ],
            [
              98.8810415739772,
              10.766776688835535
            ],
            [
              98.57430848533579,
              9.91087601931362
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}